import { render, staticRenderFns } from "./ListPurchasedPictures.vue?vue&type=template&id=1e72043a&"
import script from "./ListPurchasedPictures.vue?vue&type=script&lang=js&"
export * from "./ListPurchasedPictures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports